module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_09-624e4c9d6622e703868fcec7a2cfc1a2.svg";